import { combineReducers } from 'redux';

import {
  MainStoreOrgDashboardGradProgramsAction as GradProgramAction,
  gradProgramsReducer as gradPrograms,
} from './gradPrograms';
import { integrationsReducer as integrations } from './integrations';
import {
  MainStoreOrgDashboardListingsAction as ListingsAction,
  listingsReducer as listings,
} from './listings';
import {
  MainStoreOrgDashboardOrgsAction as OrgAction,
  orgsReducer as orgs,
} from './orgs';
import {
  MainStoreOrgDashboardSearchAction as SearchAction,
  searchReducer,
} from './search';

export type Action =
  | GradProgramAction
  | ListingsAction
  | OrgAction
  | SearchAction;

export const orgDashboardReducer = combineReducers({
  orgs,
  listings,
  search: searchReducer,
  gradPrograms,
  integrations,
});
